import * as z from 'zod';

export const RaceItemSchema = z.object({
  id: z.string(),
  checkoutItemId: z.string(),
  checkoutId: z.string(),
  eventId: z.string(),
  eventPricePointId: z.string(),
  boatClass: z.string().min(1, 'Boat class is required'),
  sailNumber: z.string().min(1, 'Sail number is required'),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type RaceItemType = z.infer<typeof RaceItemSchema>;
